import { render, staticRenderFns } from "./SettingServer.vue?vue&type=template&id=8c1ba9a6"
import script from "./SettingServer.vue?vue&type=script&lang=js"
export * from "./SettingServer.vue?vue&type=script&lang=js"
import style0 from "./SettingServer.vue?vue&type=style&index=0&id=8c1ba9a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports